import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  Payment,
  PaymentHistory,
  StripeClientSecretResponse,
  Subscription,
} from '../../Types/stripe';
import { buildUrl } from '../../Utils/Api';
import { AppSettings } from '../../Utils/Settings';

const base = 'stripe';
export const stripeApi = createApi({
  reducerPath: 'stripeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: AppSettings.ApiBaseUrl,
    prepareHeaders: async (headers, { getState }) => {
      headers.set(
        'Authorization',
        `Bearer ${localStorage.getItem('token') ?? ''}`,
      );
      return headers;
    },
  }),
  tagTypes: ['DefaultPaymentMethod'],
  endpoints: builder => ({
    CreateSetupIntent: builder.query<StripeClientSecretResponse, string>({
      query: locator => ({
        url: buildUrl(base, `create-setup-intent?locator=${locator}`),
        method: 'GET',
      }),
    }),
    GetDefaultPaymentMethod: builder.query<any, void>({
      providesTags: ['DefaultPaymentMethod'],
      query: () => ({
        url: buildUrl(base, `default-payment`),
        method: 'GET',
      }),
    }),
    DeleteDefaultPaymentMethod: builder.mutation<any, void>({
      query: () => ({
        url: buildUrl(base, `default-payment`),
        method: 'DELETE',
      }),
    }),
    SubscriptionRequest: builder.mutation<
      StripeClientSecretResponse,
      Subscription
    >({
      query: body => ({
        url: buildUrl(base, `create-checkout-session-subscription`),
        method: 'POST',
        body,
      }),
    }),
    PaymentRequest: builder.mutation<StripeClientSecretResponse, Payment>({
      query: body => ({
        url: buildUrl(base, `create-checkout-session-payment`),
        method: 'POST',
        body,
      }),
    }),
    GetPaymentHistory: builder.query<PaymentHistory[], string>({
      query: customer => ({
        url: buildUrl(base, `payments/${customer}`),
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useSubscriptionRequestMutation,
  usePaymentRequestMutation,
  useLazyCreateSetupIntentQuery,
  useGetDefaultPaymentMethodQuery,
  useDeleteDefaultPaymentMethodMutation,
  useGetPaymentHistoryQuery,
} = stripeApi;
